import { render, staticRenderFns } from "./type6.vue?vue&type=template&id=946b8466&scoped=true&"
import script from "./type6.vue?vue&type=script&lang=js&"
export * from "./type6.vue?vue&type=script&lang=js&"
import style0 from "./type6.vue?vue&type=style&index=0&id=946b8466&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946b8466",
  null
  
)

export default component.exports